import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface CreateWishlistItemRequest {
  title: string;
  description?: string;
  link?: string;
}

interface CreateWishlistItemResponse {
  id: string;
  user_id: string;
  relationship_id: string;
  title: string;
  description: string | null;
  link: string | null;
  created_at: string;
  updated_at: string;
}

export function useCreateWishlistItem(relationshipId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateWishlistItemRequest) => {
      const response = await api
        .post(`relationships/${relationshipId}/wishlist`, { json: data })
        .json<CreateWishlistItemResponse>();
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.relationship.byId(relationshipId),
      });
    },
  });
}
